import * as Yup from 'yup';
import React, { useState, useEffect } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { useFormik, Form, FormikProvider } from 'formik';
import { Icon } from '@iconify/react';
import eyeFill from '@iconify/icons-eva/eye-fill';
import eyeOffFill from '@iconify/icons-eva/eye-off-fill';
import {
  Link,
  Stack,
  Checkbox,
  TextField,
  IconButton,
  InputAdornment,
  FormControlLabel,
  Typography,
  Avatar
} from '@mui/material';
import { makeStyles, styled } from '@mui/styles';
import { useTranslation } from 'react-i18next';
import { LoadingButton } from '@mui/lab';
import { borderColor, Box } from '@mui/system';
import axios from 'axios';
import secureLocalStorage from 'react-secure-storage';
import { ToastContainer, toast } from 'material-react-toastify';
import 'material-react-toastify/dist/ReactToastify.css';
import { Button } from '../Button';

const useStyles = makeStyles((theme) => ({
  large: {
    width: 100,
    height: 100,
    border: '0.1px solid lightgray'
  },
  button: {
    borderRadius: '25px',
    backgroundColor: '#00AB55',
    color: 'white',
    paddingLeft: '10px',
    paddingRight: '10px',
    fontSize: '13px',
    textTransform: 'none',
    boxShadow: '0 8px 16px 0 rgb(0 171 85 / 24%)',
    '&:hover': {
      backgroundColor: '#1edb7c'
    }
  },
  info: {
    width: '100%',
    '@media (max-width:768px)': {
      width: '100%'
    }
  },
  form: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    '@media (max-width:768px)': {
      width: '100%',
      flexDirection: 'column'
    }
  }
}));

const CssTextField = styled(TextField)({
  '& label.Mui-focused': {
    color: '#f78181'
  },
  '& .MuiInput-underline:after': {
    borderBottomColor: '#f78181'
  },
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: 'lightgray',
      borderRadius: 0
    },
    '&:hover fieldset': {
      borderColor: '#f78181'
    },
    '&.Mui-focused fieldset': {
      borderColor: '#f78181'
    }
  }
});

export default function ContactForm() {
  const classes = useStyles();
  const navigate = useNavigate();
  const [t, i18n] = useTranslation();

  const notifySuccess = () => {
    toast.success('Your email has been sent successfully', {
      position: 'bottom-right',
      autoClose: 3000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true
    });
  };

  const LoginSchema = Yup.object().shape({
    email: Yup.string().email('Email must be a valid email address').required('Email is required'),
    name: Yup.string().required('Full Name is required')
  });

  const formik = useFormik({
    initialValues: {
      name: '',
      email: '',
      message: ''
    },
    validationSchema: LoginSchema,
    onSubmit: (values) => {
      const formData = new FormData();
      formData.append('name', values.name);
      formData.append('email', values.email);
      formData.append('message', values.message);
      const API_ENDPOINT = process.env.REACT_APP_BASE_URL;
      const token = localStorage.getItem('access');
      axios({
        method: 'post',
        url: `${API_ENDPOINT}/api/contact-us/`,
        headers: { 'Content-Type': 'multipart/form-data' },
        data: formData
      })
        .then((res) => {
          notifySuccess();
          console.log('response contact', res.data);
        })
        .catch((err) => {
          console.log('err', err);
        });
    }
  });

  const { errors, touched, values, isSubmitting, getFieldProps, setFieldValue } = formik;
  return (
    <FormikProvider value={formik}>
      <Form autoComplete="off" className={classes.form} noValidate onSubmit={formik.handleSubmit}>
        <ToastContainer />
        <Stack spacing={3} className={classes.info}>
          <CssTextField
            required
            type="text"
            label=""
            placeholder={t('name')}
            {...getFieldProps('name')}
            error={Boolean(touched.name && errors.name)}
            helperText={touched.name && errors.name}
          />
          <CssTextField
            fullWidth
            required
            autoComplete="email"
            type="email"
            label=""
            placeholder={t('email')}
            {...getFieldProps('email')}
            error={Boolean(touched.email && errors.email)}
            helperText={touched.email && errors.email}
          />
          <CssTextField
            id="message"
            name="message"
            fullWidth
            multiline
            rows={5}
            type="text"
            label=""
            placeholder={t('message')}
            {...getFieldProps('message')}
          />
          <Box textAlign="left" justifyContent="space-between">
            <Button txtBtn={t('envoyer')} widthBtn="100px" handleClick={formik.handleSubmit} />
          </Box>
        </Stack>
      </Form>
    </FormikProvider>
  );
}
